/* import __COLOCATED_TEMPLATE__ from './email-section.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SiteDocumentsContactInfoEmailSection extends Component {
  get emailIsRequired() {
    if (this.demographicsForm.isCouple) return true;

    if (this.emailTypeAttr === 'emailType') return this.#primaryEmailRequirements;

    return this.demographicsForm.isRequiredEmergencyContactEmailAddress;
  }

  get #primaryEmailRequirements() {
    return !this.demographicsForm.isMinor;
  }
}
